import * as variables from '~/styles/variables.scss';

export const name = 'creators-list';

export const FEATURE_ROUTER_PATH = `/${name}`;
export const EXPORT_PATH = `${FEATURE_ROUTER_PATH}/preview`;
export const PROFILE_PATH = `${FEATURE_ROUTER_PATH}/profile`;
export const creatorIdParamName = 'creatorId';

export const CREATOR_ACTION_ITEMS = {
    team: {
        background: variables.colorOrange,
        link: '/team',
        title: 'MY TEAM',
        iconLink: 'PeopleIcon',
    },
    deals: {
        background: variables.colorYellow,
        link: '/deals',
        title: 'MY DEALS',
        iconLink: 'PeopleIcon',
    },
    songs: {
        background: variables.colorBlue,
        link: '/songs',
        title: 'MY Music',
        iconLink: 'PeopleIcon',
    },
    money: {
        background: variables.colorGreen,
        link: '/money',
        title: 'MY MONEY',
        iconLink: 'PeopleIcon',
    },
};
